module.exports = __webpack_public_path__ + "625aca9e928c0eb9f463099945b9b115.svg";